import React from 'react'
import Create from '../crud/create'
import menuItems from './menuItems'

const CreateHomeworkTask = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Homework Task'
      fields={require('./fields')(props.params.homeworkId)}
      apiPath='admin/homework_tasks'
      successRedirectPath={`/write-now/homework/${props.params.homeworkId}/tasks?filters[homework_id]=${props.params.homeworkId}`}
      buildMenuItems={menuItems}
      resource={{ homework_id: props.params.homeworkId }}
    />
  )
}

export default CreateHomeworkTask
